import { createApi } from "@reduxjs/toolkit/query/react";
import type { IApiResponse } from "@/types";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { APIEndpoints } from "@/constants/apiEndpoints";
import type { IAiInfoExtractorRequestPayload } from "@/types/ai-api-service.interface";

export const aiAPIService = createApi({
  reducerPath: "aiAPIService",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    extractInfo: builder.mutation<IApiResponse<void>, { url: string; body: IAiInfoExtractorRequestPayload }>({
      query: ({ url, body }) => {
        return {
          url,
          method: "POST",
          body,
        };
      },
    }),
    extractInfoByAI: builder.mutation<IApiResponse<void>, IAiInfoExtractorRequestPayload>({
      query: (body) => {
        return {
          url: APIEndpoints.AI.InfoAIExtractor,
          method: "POST",
          body,
        };
      },
    })
  }),
});

export const { useExtractInfoMutation,useExtractInfoByAIMutation } = aiAPIService;
